import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class AgeStats extends PureComponent {
    renderAgeRow(age) {
        const percent = Math.round(age.percent);

        return (
            <tr key={age.name}>
                <td>{age.name} år</td>
                <td className="u-text-right">{percent}%</td>
            </tr>
        );
    }

    renderAgeList(ages) {
        const ageRows = ages.map((age) => this.renderAgeRow(age));

        return (
            <table className="data-table">
                <tbody>{ageRows}</tbody>
            </table>
        );
    }

    render() {
        if (!this.props.ages || this.props.ages.length < 0) return null;

        return (
            <div className="panel">
                <h3>Alder</h3>
                {this.renderAgeList(this.props.ages)}
            </div>
        );
    }
}

AgeStats.propTypes = {
    ages: PropTypes.array,
};

export default AgeStats;
